import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { EVariant, RealtorRequestTrapV2 } from '@cian/demand-trap-widget';
import * as React from 'react';

import * as styles from './RealtorRequestTrapContainer.css';
import { trackBannerShow, trackSendFormClick } from './tracking';
import { useApplicationContext } from '../../../common/containers/ApplicationContext';

export const RealtorRequestTrapContainer = () => {
  const { config } = useApplicationContext();
  const url = config.get<string>('requestFormRealtorFrontend.pagePath');

  if (!url) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackBannerShow} percentVisible={0.5} triggerOnce>
      <div className={styles['root']} data-testid="realtor_request_trap">
        <RealtorRequestTrapV2 href={url} variant={EVariant.C} openBlank onClick={trackSendFormClick} />
      </div>
    </ActionAfterViewObserver>
  );
};

RealtorRequestTrapContainer.displayName = 'RealtorRequestTrapContainer';
